<script setup>
/**
 * A single office address, rendered as a self-contained card. The CMS stores
 * the office name and address together as "Name：Address"; we split on the first
 * colon so the name can read as a heading. Org-wide phone/email/WhatsApp live in
 * `useSiteContact()` (rendered by ContactLayout) — they aren't per-office.
 */
const props = defineProps({ data: { type: Object, required: true } });

const parts = computed(() => {
  const idx = props.data.address.search(/[：:]/);
  if (idx === -1) return { name: "", body: props.data.address.trim() };
  return {
    name: props.data.address.slice(0, idx).trim(),
    body: props.data.address.slice(idx + 1).trim(),
  };
});
</script>

<template>
  <article class="card h-full flex items-start gap-3 p-6">
    <span class="grid h-10 w-10 flex-shrink-0 place-items-center rounded-xl bg-brand-green/10 text-brand-green" aria-hidden="true">
      <svg class="h-5 w-5" viewBox="0 0 20 20" fill="none">
        <path d="M10 18s6-5 6-10a6 6 0 10-12 0c0 5 6 10 6 10z" stroke="currentColor" stroke-width="1.4" />
        <circle cx="10" cy="8" r="2" stroke="currentColor" stroke-width="1.4" />
      </svg>
    </span>
    <div class="space-y-1">
      <h3 v-if="parts.name" class="font-display text-lg font-bold leading-snug text-ink">{{ parts.name }}</h3>
      <p class="text-[15px] leading-relaxed text-ink/75">{{ parts.body }}</p>
    </div>
  </article>
</template>
